import { render, staticRenderFns } from "./MDTQuestions.vue?vue&type=template&id=ab0f995e&"
import script from "./MDTQuestions.vue?vue&type=script&lang=ts&"
export * from "./MDTQuestions.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/home/circleci/repo/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('ab0f995e')) {
      api.createRecord('ab0f995e', component.options)
    } else {
      api.reload('ab0f995e', component.options)
    }
    module.hot.accept("./MDTQuestions.vue?vue&type=template&id=ab0f995e&", function () {
      api.rerender('ab0f995e', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/components/data-entry/views/MDTQuestions.vue"
export default component.exports